// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

// --- RxJs
import { Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

// --- HS Code
import { OidcService } from '../services/account/oidc.service';
import { AppService } from '../services/app.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private oidcService: OidcService, private appService: AppService) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.oidcService.waitForAuthenticationLoaded().pipe(
      switchMap(loading => {
        return this.oidcService.identity$.pipe(
          first(),
          switchMap(user => {
            if (user && !user.expired) {
              return of(true);
            } else {
              this.appService.setLoading(true);
              this.oidcService.signInRedirect();
              this.router.navigate(['/login']);
              return of(false);
            }
          })
        );
      })
    );
  }
}
